import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Container, Button, Hidden } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionShopCartAddEventWithTourHold, actionShopCartSetManageMyBooking, actionShopCartSetMmbAmountToPay, actionShopCartSetEnteredAmountToPay,
    actionShopCartResetError, actionShopCartResetMembership, actionShopCartSetRefundType, actionShopCartResetIDME
} from 'actions';
import { actionResetBooking, actionUpdateQuantity } from 'actions';
import { NumberSpinner } from '../../components/InputControls';
import { genfunction } from '../../helpers';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionGetExtraItem, actionIncreaseQuantity, actionResetExtraItems } from 'actions';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const { ModifyTicketsHeading, RefundCreditCardButton, RefundGiftCardButton, ApplyCostRatesOnManageMyBooking, ApplyCostRatesOnManageMyBookingText } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    },
    hideBtn: {
        display: 'none'
    }
}));

const ModifyTicketsAddons = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const reducerBooking = useSelector(state => state.reducerBooking);
    const currentDateEvent = useSelector(state => state.reducerExtraItems.extraItem);
    const cartEvents = useSelector(state => state.reducerShopCart.events);
    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    let bookingID = reducerBooking && reducerBooking.booking[0] ? reducerBooking.booking[0].BookingTypeID : 0;
    const bkngType = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID == bookingID)[0] : null;
    const extramItemsstate = useSelector(state => state.reducerExtraItems);
    const shopcartreducer = useSelector(state => state.reducerShopCart);

    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);

    const [errorMsg, seterrorMsg] = useState("");
    const [isredirectclicked, setisredirectclicked] = useState(false);
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const errorcancelhandle = () => {
        actionShopCartResetError(dispatch);
        seterrorMsg("");
    }


    useEffect(() => {
        if (reducerBooking.booking) {
            if (reducerBooking.booking.length < 1) {
                // props.history.push({
                //     pathname: '/findmybooking'
                // })
            }
        }
    }, []);

    const changeQuantityHandler = (reference, quantity) => {

        if (cartEvents !== undefined && cartEvents.length > 0) {
            if (cartEvents[0].TourProducts.filter(x => x.AffectsCapacity).length > 0) {
                actionIncreaseQuantity(dispatch, reference.TourProductID, quantity, true, reference.MinimumTickets, reference.MaximumTickets);
                return;
            }
        }
        actionIncreaseQuantity(dispatch, reference.TourProductID, quantity, false, reference.MinimumTickets, reference.MaximumTickets);
    }

    const changeQuantityCurrentBooking = (reference, quantity) => {
        if (reducerBooking && reducerBooking.booking[0]) {
            if (quantity < reference.MinimumTickets) {
                seterrorMsg("Minimum tickets for this event is " + reference.MinimumTickets + ".")
                return;
            }

            actionUpdateQuantity(dispatch, reference.TourProductID, quantity);

            return;
        }
    }

    useEffect(() => {
        let tourevntID = props.location.toureventID ? props.location.toureventID : reducerBooking.booking[0] ? reducerBooking.booking[0].TourEventID : 0;
        let memcstRate = reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('CustomerCostRateID') ? reducerBooking.booking[0].CustomerCostRateID : 0;
        actionGetExtraItem(dispatch, tourevntID, ApplyCostRatesOnManageMyBooking, memcstRate);
    }, []);

    useEffect(() => {
        if (extramItemsstate.loading == true) {
            actionStartAppLoader(dispatch);
        }
        else {
            actionEndAppLoader(dispatch);
        }
    })

    const constredirecttofindmybpooking = () => {
        actionResetBooking(dispatch);
        actionResetExtraItems(dispatch);
        actionShopCartSetManageMyBooking(dispatch, false, true);
        actionShopCartResetMembership(dispatch);
        actionShopCartResetIDME(dispatch);

        props.history.push({
            pathname: '/findmybooking'
        })
    }

    const addeventstotourholdaction = () => {

        let filterdata = { ...currentDateEvent };
        filterdata.TourProducts = filterdata.TourProducts.filter(product => product.Quantity > 0);
        let cartdata = [...cartEvents];

        if (filterdata && filterdata.hasOwnProperty('BookingTypeID')) {
            let usealternamteMerchant = false;
            if (bkngType && bkngType.hasOwnProperty('UseAlternateMerchant')) {
                usealternamteMerchant = bkngType.UseAlternateMerchant;
            }

            filterdata.UseAlternateMerchant = usealternamteMerchant;

        }


        actionShopCartAddEventWithTourHold(dispatch, filterdata, cartdata);

        actionShopCartSetManageMyBooking(dispatch, true, true);
    }

    useEffect(() => {

        if (isredirectclicked && shopcartreducer.error.length < 1 && shopcartreducer.events && shopcartreducer.events.length > 0) {
            let amountToPay = returnproducts();

            amountToPay = addTransFeeWithBalance(amountToPay);

            actionShopCartSetMmbAmountToPay(dispatch, amountToPay);

            props.history.push({
                pathname: '/managecheckout',
                refundType: ''
            })
        }
        if (isredirectclicked && shopcartreducer.error.length > 0) {
            seterrorMsg(shopcartreducer.error);
            setisredirectclicked(false);
        }
    }, [cartEvents, shopcartreducer.error.length > 0]);

    const addTransFeeWithBalance = (balanceOwe) => {

        if (transactionfee.transactionFee && transactionfee.transactionFee.length > 0) {
            if (transactionfee.transactionFee[0].TransactionFeeByDefault) {
                let transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], balanceOwe, cashlesstotal)

                if (transFee > 0) {
                    actionShopCartSetEnteredAmountToPay(dispatch, balanceOwe);
                    return genfunction.Rounded(balanceOwe + transFee);
                }
            }
        }
        return balanceOwe;
    }

    const constredirecttomanagecheckout = () => {

        if (ValidateQuanity()) {
            let amounttop = returnproducts();

            let NewQty = currentDateEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;

            let PreviousQtyChanges = false;

            if (reducerBooking.booking[0].BookingProducts) {
                PreviousQtyChanges = reducerBooking.booking[0].BookingProducts.filter(x => x.isModify).length > 0 ? true : false;
            }

            if (amounttop === 0 && NewQty == 0 && !PreviousQtyChanges) {
                seterrorMsg("No tickets changes are applied.")
                return;
            }

            if (amounttop >= 0) {

                addeventstotourholdaction();
                setisredirectclicked(true);
            }
            else {
                handleClickOpen();
            }
        }

    }

    const ValidateQuanity = () => {
        let MinTicket = bkngType.MinimumTickets
        let MaxTicket = bkngType.MaximumTickets;

        let CartQty = 0;
        let NewQty = 0;
        let TotalTicketCount = 0;
        if (cartEvents && cartEvents.length > 0) {

            let cartTourEvent = cartEvents.find(x => x.TourEventID == currentDateEvent.TourEventID);
            if (cartTourEvent && cartTourEvent.TourProducts.length > 0) {
                CartQty = cartTourEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
                    let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                    let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                    let newobj = { Quantity: aqty + bqty }
                    return newobj;
                }).Quantity;
            }
        }

        NewQty = currentDateEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
            let aqty = a.Quantity === undefined ? 0 : a.Quantity;
            let bqty = b.Quantity === undefined ? 0 : b.Quantity;
            let newobj = { Quantity: aqty + bqty }
            return newobj;
        }).Quantity;

        TotalTicketCount = CartQty + NewQty;

        if (currentDateEvent.SeatsAvailable == 0 || currentDateEvent.BookNowOption != "Book Now") {
            seterrorMsg("Tickets not longer available, please choose another time");
            return false;
        }
        else if (NewQty > currentDateEvent.SeatsAvailable) {
            seterrorMsg("Maximum of " + currentDateEvent.SeatsAvailable + " tickets available");
            return false;
        }
        else if (TotalTicketCount > MaxTicket) {
            seterrorMsg("Maximum of " + MaxTicket + " tickets allowed")
            return false;
        }
        else {
            return true;
        }
    }

    const applyrefund = (type) => {

        addeventstotourholdaction();
        actionShopCartSetMmbAmountToPay(dispatch, returnproducts());
        actionShopCartSetRefundType(dispatch, type);

        props.history.push({
            pathname: '/managecheckout',
            refundType: type
        })
    }

    const CalculateMaxTickets = (TourProductID) => {
        let shopCartConsumed = 0;

        if (cartEvents && cartEvents.length > 0) {
            let cartTourEvent = cartEvents.find(x => x.TourEventID == currentDateEvent.TourEventID);
            if (cartTourEvent && cartTourEvent.TourProducts.length > 0 && cartTourEvent.TourProducts.filter(p => p.AffectsCapacity).length > 0) {
                shopCartConsumed = cartTourEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
                    let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                    let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                    let newobj = { Quantity: aqty + bqty }
                    return newobj;
                }).Quantity;
            }
        }

        let consumedQty = 0;
        if (currentDateEvent.TourProducts.filter(p => p.TourProductID != TourProductID && p.AffectsCapacity).length > 0) {
            consumedQty = currentDateEvent.TourProducts.filter(p => p.TourProductID != TourProductID && p.AffectsCapacity).reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = (b === undefined || b.Quantity === undefined) ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;
        }

        return bkngType !== undefined ? bkngType.MaximumTickets - consumedQty - shopCartConsumed : 0;
    }

    const totalpaid = () => {
        let total = 0;
        if (reducerBooking.booking && reducerBooking.booking[0] && reducerBooking.booking[0].BookingPayments && reducerBooking.booking[0].BookingPayments.length > 0) {
            total = reducerBooking.booking[0].BookingPayments.map(({ PaymentAmount }) => PaymentAmount).reduce((sum, i) => sum + i, 0);
        }

        return total;
    }

    const returnproducts = () => {
        let total = 0;
        let actualTotal = 0;
        let newTotal = 0;
        let eventTotal = currentDateEvent.TotalAmount ? currentDateEvent.TotalAmount : 0;

        if (reducerBooking.booking && reducerBooking.booking[0] && reducerBooking.booking[0].BookingPayments && reducerBooking.booking[0].BookingPayments.length > 0) {
            actualTotal = parseFloat(Math.round(reducerBooking.booking[0].BookingProducts.map(({ ProductLinePriceInclTax }) => ProductLinePriceInclTax).reduce((sum, i) => sum + i, 0) * 100) / 100).toFixed(2);
            reducerBooking.booking[0].BookingProducts.map(prod => {
                if (prod.hasOwnProperty('isModify') && prod.isModify) {
                    newTotal += prod.newQuantity * (prod.ProductLinePriceInclTax / prod.Quantity);
                }
                else {
                    newTotal += prod.ProductLinePriceInclTax;
                }
            })

            total = parseFloat(Math.round((actualTotal - newTotal) * 100) / 100).toFixed(2);
        }

        return eventTotal - parseFloat(total);
    }

    const totalpayments = () => {
        let total = 0;
        if (reducerBooking.booking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('BookingPayments') && reducerBooking.booking[0].BookingPayments.length > 0) {
            total = reducerBooking.booking[0].BookingPayments.length;
        }

        return total;
    }


    const eligibletxtReturnClass = () => {
        let eligibleTxt = "";
        if (reducerBooking.booking[0]) {
            if (reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefunds && totalpayments() === 1 && reducerBooking.booking[0].AllowRefundToGiftcardOnly) {

                if (reducerBooking.booking[0].hasOwnProperty('PaymentToken')) {
                    eligibleTxt = "You are eligible for a refund of " + (reducerBooking.booking[0] ? genfunction.ccyFormat(Math.abs(returnproducts())) : 0) + " to a gift card or card on file " + (reducerBooking.booking[0].PaymentDescription !== undefined ? reducerBooking.booking[0].PaymentDescription : '');
                }
                else {
                    eligibleTxt = "You are eligible for a refund of " + (reducerBooking.booking[0] ? genfunction.ccyFormat(Math.abs(returnproducts())) : 0) + " to a gift card.";
                }
            }
            else if (reducerBooking.booking[0].AllowRefundToGiftcardOnly && reducerBooking.booking[0].AllowRefunds == false) {
                eligibleTxt = "You are eligible for a refund of " + (reducerBooking.booking[0] ? genfunction.ccyFormat(Math.abs(returnproducts())) : 0) + " to a gift card.";
            }
            else if (reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefunds && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken')) {
                eligibleTxt = "You are eligible for a refund of " + (reducerBooking.booking[0] ? genfunction.ccyFormat(Math.abs(returnproducts())) : 0) + " through card on file " + (reducerBooking.booking[0].PaymentDescription !== undefined ? reducerBooking.booking[0].PaymentDescription : '');
            }

            return eligibleTxt;
        }
    }

    const redirecttofindmybpooking = () => {

        props.history.push({
            pathname: '/findmybooking'
        })
    }

    return (


        //Desktop and Laptop (smDown)
        //Tablet (xsDown mdUp)
        //Mobile (smUp)

        <Container className={classes.root}>
            <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
            <Grid container justify="center" spacing={1} className={reducerBooking.booking[0] && reducerBooking.booking[0].BookingID ? '' : classes.hideBtn}>
                <Grid item xs={12} md={7}>

                    <Hidden smDown>
                        <Typography align="center" variant="h1" style={{ padding: "5px", fontWeight: "bold" }} >
                            {ModifyTicketsHeading}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography align="center" variant="h2" style={{ padding: "5px", fontWeight: "bold" }} >
                            {ModifyTicketsHeading}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography align="center" variant="h3" style={{ padding: "5px", fontWeight: "bold" }} >
                            {ModifyTicketsHeading}
                        </Typography>
                    </Hidden>
                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Current Tickets
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Current Tickets
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Current Tickets
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography align="center" variant="h6" style={{ padding: "10px" }}>
                            These are the current tickets in your existing order. You can either remove items here and/or use the section below to add any available tickets to your order.
                        </Typography>

                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography align="center" variant="subtitle1" style={{ padding: "10px" }}>
                            These are the current tickets in your existing order. You can either remove items here and/or use the section below to add any available tickets to your order.
                        </Typography>

                    </Hidden>

                    <Hidden smUp>
                        <Typography align="center" variant="subtitle2" style={{ padding: "10px" }}>
                            These are the current tickets in your existing order. You can either remove items here and/or use the section below to add any available tickets to your order.
                        </Typography>

                    </Hidden>


                    <Grid item xs={10} md={10} style={{ margin: "auto" }}>
                        {reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty("BookingProducts") ?
                            reducerBooking.booking[0].BookingProducts.map((product, i) => {

                                return product.Quantity ?

                                    <Grid style={{ padding: "5px" }} container alignItems="center" item xs={12} ms={12} lg={12} key={product.TourProductID}>

                                        <Grid item xs={5} ms={5} lg={5}>

                                            <Hidden smDown>
                                                <Typography variant="h5">{product.TourProductName + ' ' + genfunction.ccyFormat(product.Price)}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="h6">{product.TourProductName + ' ' + genfunction.ccyFormat(product.Price)}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="subtitle1">{product.TourProductName + ' ' + genfunction.ccyFormat(product.Price)}</Typography>
                                            </Hidden>

                                        </Grid>

                                        <Grid item xs={5} ms={5} lg={4} align="center">
                                            <NumberSpinner
                                                refrence={{
                                                    TourProductID: product.TourProductID,
                                                    MaximumTickets: bkngType !== undefined ? bkngType.MaximumTickets : 0,
                                                    MinimumTickets: bkngType !== undefined ? bkngType.MinimumTickets : 0
                                                }}
                                                value={product.hasOwnProperty('newQuantity') ? product.newQuantity : product.Quantity}
                                                minValue={0}
                                                maxValue={product.hasOwnProperty('newQuantity') ? product.newQuantity : product.Quantity}
                                                steps={1}
                                                changeHandler={changeQuantityCurrentBooking}
                                                disabled={product.Price < 0 || product.IsRefundable === false ? true : false}
                                            ></NumberSpinner>
                                        </Grid>

                                        <Grid item xs={2} ms={2} lg={3} >
                                            <Hidden smDown>
                                                <Typography variant="body1" style={{ color: "Red" }}>{product.IsRefundable === false ? "Not Refundable" : ""}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="body2" style={{ color: "Red" }}>{product.IsRefundable === false ? "Not Refundable" : ""}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="body2" style={{ color: "Red" }}>{product.IsRefundable === false ? "Not Refundable" : ""}</Typography>
                                            </Hidden>

                                        </Grid>
                                    </Grid>
                                    : null
                            }) : null}
                    </Grid>
                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "15px" }}>

                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Tickets Available
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Tickets Available
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Tickets Available
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h6" align="center" style={{ padding: "10px" }}>
                            Use plus button to add tickets to this reservation.
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="subtitle1" align="center" style={{ padding: "10px" }}>
                            Use plus button to add tickets to this reservation.
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="subtitle2" align="center" style={{ padding: "10px" }}>
                            Use plus button to add tickets to this reservation.
                        </Typography>
                    </Hidden>


                    <Grid item xs={10} md={10} style={{ margin: "auto" }}>
                        {currentDateEvent.hasOwnProperty("TourProducts") ?
                            currentDateEvent.TourProducts.map((product, i) => {

                                return product.AffectsCapacity && product.AvailableOnline && product.PriceMatrix !== undefined && product.PriceMatrix.length > 0
                                    && product.TourProductID !== bkngType.ChaperoneTourProductID ?

                                    <Grid style={{ padding: "5px" }} container alignItems="center" item xs={12} ms={12} lg={12} key={product.TourProductID}>
                                        <Grid item xs={4} ms={4} lg={4}>

                                            <Hidden smDown>
                                                <Typography variant="h5">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="h6">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="subtitle1">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>
                                        </Grid>

                                        <Grid item xs={5} ms={5} lg={5} align="center">
                                            <NumberSpinner
                                                refrence={{
                                                    TourProductID: product.TourProductID,
                                                    MaximumTickets: bkngType !== undefined ? bkngType.MaximumTickets : 0,
                                                    MinimumTickets: bkngType !== undefined ? bkngType.MinimumTickets : 0
                                                }}
                                                value={product.Quantity === undefined ? 0 : product.Quantity}
                                                minValue={0}
                                                maxValue={CalculateMaxTickets(product.TourProductID)}
                                                steps={1}
                                                changeHandler={changeQuantityHandler}
                                                disabled={currentDateEvent.hasOwnProperty('SeatsAvailable') && currentDateEvent.SeatsAvailable < 1 ? true : false}
                                            ></NumberSpinner>
                                        </Grid>
                                        {<Grid item xs={3} ms={3} lg={3}>
                                            <Hidden smDown>
                                                <Typography variant="body1" style={{ color: "Red" }}>{currentDateEvent.hasOwnProperty('SeatsAvailable') && currentDateEvent.SeatsAvailable < 1 ? "No available tickets" : ""}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="body2" style={{ color: "Red" }}>{currentDateEvent.hasOwnProperty('SeatsAvailable') && currentDateEvent.SeatsAvailable < 1 ? "No available tickets" : ""}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="body2" style={{ color: "Red" }}>{currentDateEvent.hasOwnProperty('SeatsAvailable') && currentDateEvent.SeatsAvailable < 1 ? "No available tickets" : ""}</Typography>
                                            </Hidden>

                                        </Grid>}
                                    </Grid>
                                    : null
                            }) : null}

                        <Hidden smDown>
                            <Typography variant="h6" align="center" style={{ padding: "10px" }}>
                                Use plus and minus buttons to adjust selected add ons.
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography variant="subtitle1" align="center" style={{ padding: "10px" }}>
                                Use plus and minus buttons to adjust selected add ons.
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography variant="subtitle2" align="center" style={{ padding: "10px" }}>
                                Use plus and minus buttons to adjust selected add ons.
                            </Typography>
                        </Hidden>

                        {currentDateEvent.hasOwnProperty("TourProducts") ?
                            currentDateEvent.TourProducts.map((product, i) => {

                                return product.AffectsCapacity === false && product.AvailableOnline && product.PriceMatrix !== undefined && product.PriceMatrix.length > 0
                                    && product.TourProductID !== bkngType.ChaperoneTourProductID ?

                                    <Grid style={{ padding: "10px" }} container alignItems="center" item xs={12} ms={12} lg={12} key={product.TourProductID}>
                                        <Grid item xs={4} ms={4} lg={4}>

                                            <Hidden smDown>
                                                <Typography variant="h5">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="h6">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="subtitle1">{product.TourProductName + ' ' + genfunction.ccyFormat(product.PriceMatrix[0].Price)}</Typography>
                                            </Hidden>

                                        </Grid>

                                        <Grid item xs={5} ms={5} lg={5} align="center">
                                            <NumberSpinner
                                                refrence={{
                                                    TourProductID: product.TourProductID,
                                                    MaximumTickets: bkngType !== undefined ? bkngType.MaximumTickets : 0,
                                                    MinimumTickets: bkngType !== undefined ? bkngType.MinimumTickets : 0
                                                }}
                                                value={product.Quantity === undefined ? 0 : product.Quantity}
                                                minValue={0} maxValue={999} steps={1}
                                                changeHandler={changeQuantityHandler}
                                            ></NumberSpinner>
                                        </Grid>
                                    </Grid>
                                    : null
                            }) : null}
                    </Grid>
                </Grid>

                <Grid item xs={12} md={7} style={{ padding: "20px" }}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "5px" }}>
                            Booking Summary
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: "5px" }}>
                            Booking Summary
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: "7px" }}>
                            Booking Summary
                        </Typography>
                    </Hidden>


                    {ApplyCostRatesOnManageMyBooking &&

                        <Grid item xs={12} md={12} align="center" style={{ paddingTop: "15px" }}>
                            <Typography className={classes.italicGrey} component="span" >
                                {ApplyCostRatesOnManageMyBookingText}
                            </Typography>
                        </Grid>

                    }

                    <Hidden smDown>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            Current Booking Cost : {reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            Current Booking Cost : {reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            Current Booking Cost : {reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            New Total Cost : {genfunction.ccyFormat(returnproducts())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            New Total Cost : {genfunction.ccyFormat(returnproducts())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            New Total Cost : {genfunction.ccyFormat(returnproducts())}
                        </Typography>
                    </Hidden>

                    <Grid item xs={12} md={12} align="center" style={{ marginTop: "30px" }}>

                        <Hidden smDown>
                            <Button variant="outlined" size="medium" color="primary"
                                style={{ padding: "12px", marginTop: 0 }}
                                onClick={() => constredirecttofindmybpooking()}>
                                Cancel Changes
                            </Button>

                            <Button variant="contained" size="medium" color="primary"
                                style={{ padding: "12px", marginLeft: 10, marginTop: 0 }}
                                onClick={() => constredirecttomanagecheckout()}>
                                Confirm Changes
                            </Button>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Button variant="outlined" size="small" color="primary"
                                style={{ padding: "12px", marginTop: 10 }}
                                onClick={() => constredirecttofindmybpooking()}>
                                Cancel Changes
                            </Button>

                            <Button variant="contained" size="small" color="primary"
                                style={{ padding: "12px", marginLeft: 10, marginTop: 10 }}
                                onClick={() => constredirecttomanagecheckout()}>
                                Confirm Changes
                            </Button>
                        </Hidden>

                        <Hidden smUp>
                            <Button variant="outlined" size="small" color="primary"
                                style={{ padding: "12px", marginTop: 10 }}
                                onClick={() => constredirecttofindmybpooking()}>
                                Cancel Changes
                            </Button>

                            <Button variant="contained" size="small" color="primary"
                                style={{ padding: "12px", marginLeft: 10, marginTop: 10 }}
                                onClick={() => constredirecttomanagecheckout()}>
                                Confirm Changes
                            </Button>
                        </Hidden>
                    </Grid>
                </Grid>
            </Grid>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
            >
                <DialogTitle id="alert-dialog-title">{"Refund Transaction"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">


                        <Hidden smDown>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Your previous payment: " + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0)}
                            </Typography>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Now we owe you: " + genfunction.ccyFormat(Math.abs(returnproducts()))}
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Your previous payment:" + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0)}
                            </Typography>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Now we owe you: " + genfunction.ccyFormat(Math.abs(returnproducts()))}
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Your previous payment:" + (reducerBooking.booking[0] ? genfunction.ccyFormat(totalpaid()) : 0)}
                            </Typography>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                {"Now we owe you: " + genfunction.ccyFormat(Math.abs(returnproducts()))}
                            </Typography>
                        </Hidden>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Hidden smDown>

                        <Button onClick={handleClose} variant="outlined" size="medium" color="primary">
                            Cancel Changes
                        </Button>

                        <Button onClick={() => applyrefund('CreditCardRefund')} variant="contained" size="medium" color="primary"
                            className={reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefunds && reducerBooking.booking[0].AllowRefundToGiftcardOnly === false && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken') ? '' : classes.hideBtn}  >
                            {RefundCreditCardButton}
                        </Button>

                        <Button
                            onClick={() => applyrefund('GiftCardRefund')}
                            variant="contained" size="medium" color="primary"
                            className={reducerBooking.booking[0] && (reducerBooking.booking[0].AllowRefunds || reducerBooking.booking[0].AllowRefundToGiftcardOnly) ? '' : classes.hideBtn}  >
                            {RefundGiftCardButton}
                        </Button>
                    </Hidden>

                    <Hidden xsDown mdUp>

                        <Button onClick={handleClose} variant="outlined" size="small" color="primary">
                            Cancel Changes
                        </Button>

                        <Button onClick={() => applyrefund('CreditCardRefund')} variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefunds && reducerBooking.booking[0].AllowRefundToGiftcardOnly === false && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken') ? '' : classes.hideBtn}  >

                            {RefundCreditCardButton}
                        </Button>

                        <Button
                            onClick={() => applyrefund('GiftCardRefund')}
                            variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && (reducerBooking.booking[0].AllowRefunds || reducerBooking.booking[0].AllowRefundToGiftcardOnly) ? '' : classes.hideBtn}  >
                            {RefundGiftCardButton}
                        </Button>

                    </Hidden>

                    <Hidden smUp>
                        <Button onClick={handleClose} variant="outlined" size="small" color="primary">
                            Cancel Changes
                        </Button>

                        <Button onClick={() => applyrefund('CreditCardRefund')} variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && reducerBooking.booking[0].AllowRefunds && reducerBooking.booking[0].AllowRefundToGiftcardOnly === false && totalpayments() === 1 && reducerBooking.booking[0].hasOwnProperty('PaymentToken') ? '' : classes.hideBtn}  >

                            {RefundCreditCardButton}
                        </Button>

                        <Button
                            onClick={() => applyrefund('GiftCardRefund')}
                            variant="contained" size="small" color="primary"
                            className={reducerBooking.booking[0] && (reducerBooking.booking[0].AllowRefunds || reducerBooking.booking[0].AllowRefundToGiftcardOnly) ? '' : classes.hideBtn}  >
                            {RefundGiftCardButton}
                        </Button>
                    </Hidden>

                </DialogActions>
            </Dialog>




            <Grid container alignItems="center" style={{ minHeight: '10vh', marginTop: 30 }} justify="center" spacing={0} className={reducerBooking.booking[0] && reducerBooking.booking[0].BookingID ? classes.hideBtn : ''}>
                <Typography variant="h4" className={classes.AdjustContext}>
                    Please go to find my booking page to Update Booking.
                </Typography>
                <Grid item xs={12} md={12} align="center">

                    <Button variant="outlined" size="medium" color="primary" className={classes.AdjustContext} style={{ padding: "12px" }}
                        onClick={() => redirecttofindmybpooking()}>
                        Manage My Booking
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ModifyTicketsAddons;
